let bookTypes = [
  { id: 0, label: "Free", selected: false },
  { id: 1, label: "Premium", selected: false },
];

let quiz = [
  { id: 0, label: "Yes", selected: false },
  { id: 1, label: "No", selected: false },
];

let language = [
  { id: 0, label: "Urdu", selected: false },
  { id: 1, label: "English", selected: false },
];

let hardCopy = [
  { id: 0, label: "Yes", selected: false },
  { id: 1, label: "No", selected: false },
];

let newArrivals = [
  {
    id: 0,
    label: "Book Name 1",
    selected: false,
  },
  {
    id: 1,
    label: "Book Name 2",
    selected: false,
  },
  {
    id: 2,
    label: "Book Name 3",
    selected: false,
  },
];

export { bookTypes, quiz, language, hardCopy, newArrivals };
